module.exports = __webpack_public_path__ + "static/media/washington_sport.d7fdb4c1.jpg";